import * as actions from './phases.actions'

const initialState = {
  phase: 0,
  error: null,
}

const actionsMap = {
  [actions.GO_TO_PHASE_SUCCESS]: (state, action) => ({
    ...state,
    phase: action.data,
  }),
}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
